function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-iso-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import { HelpText, Table } from '@applyboard/crystal-ui';
import { capitalize } from 'lodash';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: Fix circular dependency
import { useApplicationPagePermissions, useLegacyApplicationRequirements } from "../../pages/StudentApplication/data";
import { TimelessDateStringInput } from "../TimelessDateStringInput";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var RequirementDeadlinesTable = function RequirementDeadlinesTable(_ref) {
  var helpText = _ref.helpText,
    invalid = _ref.invalid,
    _onChange = _ref.onChange,
    value = _ref.value,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate;
  var _useLegacyApplication = useLegacyApplicationRequirements(),
    applicationRequirements = _useLegacyApplication.applicationRequirements;
  var requirementsWithDeadlines = getRelevantRequirements(applicationRequirements);
  var tableData = requirementsWithDeadlines.map(function (requirement, index) {
    return {
      arrayIndex: index,
      templateId: requirement.requirementTemplateId,
      internalTitle: requirement.internalTitle,
      requirementStage: capitalize(requirement.applicationStage),
      deadline: requirement.deadline
    };
  });
  var _useApplicationPagePe = useApplicationPagePermissions(),
    permissions = _useApplicationPagePe.permissions;
  if (tableData.length === 0) {
    return _jsx(HelpText, {
      showIcon: true,
      intent: "secondary",
      children: "There are no outstanding application requirements with a deadline."
    });
  }
  return _jsxs(_Fragment, {
    children: [_jsx(Table, {
      columns: [{
        accessorKey: 'templateId',
        header: 'Template ID'
      }, {
        accessorKey: 'internalTitle',
        header: 'Internal title'
      }, {
        accessorKey: 'requirementStage',
        header: 'Requirement stage'
      }, {
        accessorKey: 'deadline',
        header: 'Deadline',
        cell: function cell(_ref2) {
          var arrayIndex = _ref2.arrayIndex;
          return _jsx(Table.Cell, {
            children: _jsx(TimelessDateStringInput, {
              onChange: function onChange(selectedDate) {
                var newValue = _toConsumableArray(value);
                newValue[arrayIndex] = _objectSpread(_objectSpread({}, value[arrayIndex]), {}, {
                  deadline: selectedDate
                });
                _onChange(newValue);
              },
              minDate: minDate.toISOString(),
              maxDate: maxDate.toISOString(),
              value: value[arrayIndex].deadline,
              disabled: !(permissions !== null && permissions !== void 0 && permissions['modify_application_requirement_deadline'])
            }, arrayIndex)
          });
        }
      }],
      data: tableData
    }), helpText && _jsx(HelpText, {
      intent: invalid ? 'negative' : 'secondary',
      showIcon: invalid,
      children: helpText
    })]
  });
};
export var getRelevantRequirements = function getRelevantRequirements(requirements) {
  return requirements.filter(function (requirement) {
    var _requirement$deadline;
    return requirement.classification === 'applicant_requirement' && ['required_state_optional', 'required_state_required'].includes(requirement.requiredState) && ['status_missing', 'status_reviewing', 'status_not_approved'].includes(requirement.status) && ((_requirement$deadline = requirement.deadline) === null || _requirement$deadline === void 0 ? void 0 : _requirement$deadline.length);
  });
};